<template>
<form
  :method="methodType"
  accept-charset="UTF-8"
  autocomplete="off"
  :action="actionUrl"
  id="purchaseForm"
  :reset="true"
  v-on:submit.prevent="submit"
>
  <div class="form-group">
    <label for="purchase-customer-email">
      Customer Email
    </label>
    <input
      type="email"
      name="purchase[customer_email]"
      id="purchase-customer-email"
      v-model="customer_email"
      class="form-control"
      required="true"
    />
  </div>

  <div class="form-group">
    <label for="purchase-recipient-email">
      Recipient Email
    </label>
    <input
      type="email"
      name="purchase[recipient_email]"
      id="purchase-recipient-email"
      v-model="recipient_email"
      class="form-control"
      required="true"
    />
  </div>
  <div class="form-group">
    <label for="purchase_gift">
      <input type="hidden" name="purchase[gift]" value="false" />
      <input
        type="checkbox"
        id="purchase_gift"
        name="purchase[gift]"
        v-model="gift"
      />
      Gift?
    </label>
  </div>
  <div class="form-group">
    <label
      for="purchase_suppress_email"
    >
      <input
        type="checkbox"
        name="purchase[suppress_email]"
        id="purchase_suppress_email"
      />

      Suppress Purchase Confirmation Email?
    </label>
  </div>

  <div class="form-group row">
    <div class="col">
      <label for="purchase-purchasable-item-search">
        Purchased Items
      </label>

      <!--
      <input
        type="text"
        name="purchasable-item-search"
        placeholder="Search for Items"
        class="form-control"
        v-model="query"
        v-on:keyup="searchPurchasableItems"
      />
      -->
      <purchasable-item-search />
    </div>
  </div>

  <div class="form-group row"
    v-if="found_purchasable_items && found_purchasable_items.length"
  >
    <div class="col-2">
      <label for="purchase-purchasable-item-search-results">
        Found Purchasable Items
      </label>
    </div>
    <div class="col-9">
      <select
        class="form-control"
        id="found-purchasable-items"
        name="found_purchasable_items"
      >
        <option
          v-for="result in found_purchasable_items"
           v-bind:value="result.id"
           :data-price="result.price"
           :data-subscription="result.subscription"
        >
          {{ result.name }}
        </option>
      </select>
    </div>
    <div class="col-1 text-center">
      <button
        class="btn btn-primary"
        v-on:click.prevent="addPurchasableItem"
      >
        Add
      </button>
    </div>
  </div>
  <div v-else-if="query">
    <p class="alert alert-warning" role="alert">
      No items found.
    </p>
  </div>

  <div class="form-group">
    <h4>Purchased Items</h4>

    <div v-if="purchasable_items && purchasable_items.length">
      <div class="form-check" v-for="item in this.purchasable_items">
        <label
          class="form-check-label"
          :for="'purchasable-item-' + item.id"
        >
          <input
            type="checkbox"
            name="purchase[purchasable_item_ids][]"
            class="form-check-input"
            :id="'purchasable-item-' + item.id"
            :value="item.id"
            checked="checked"
            v-on:click="removePurchasableItem"
          >
          {{ item.name }} - ${{ item.price }}
        </label>
      </div>
    </div>
    <div v-else>
      No items selected.
    </div>
  </div>

  <div class="form-group row">
    <div class="col">
      <label for="purchase-price">
        Gross
      </label>
      <div class="input-group">
        <span class="input-group-addon">$</span>
        <input
          type="number"
          name="purchase[gross]"
          id="purchase-gross"
          step=".01"
          v-model="gross"
          class="form-control"
        />
      </div>
    </div>

    <div class="col">
      <label for="purchase-fee">
        Fee
      </label>
      <div class="input-group">
        <span class="input-group-addon">$</span>
        <input
          type="number"
          name="purchase[fee]"
          id="purchase-fee"
          step=".01"
          v-model="fee"
          class="form-control"
        />
      </div>
    </div>

    <div class="col">
      <label for="purchase-net">
        Net
      </label>
      <div class="input-group">
        <span class="input-group-addon">$</span>
        <input
          type="number"
          name="purchase[net]"
          id="purchase-net"
          step=".01"
          v-model="net"
          class="form-control"
        />
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-auto">
      <div class="input-group">
        <!--
        <input
          type="date"
          name="purchased_at_date"
          id="purchase-purchased-at-date"
          class="form-control"
          v-model="purchased_at_date"
        />

        <input
          type="time"
          name="purchased_at_time"
          id="purchase-purchased-at-time"
          class="form-control"
          v-model="purchased_at_time"
        />

        <input
          type="hidden"
          name="purchase[purchased_at]"
          id="purchase-purchased-at"
          v-model="purchased_at"
        />-->

        <purchased-at
          labelText="Purchased At"
          name="purchase[purchased_at]"
          :value="purchased_at"
        />
      </div>
    </div>

    <div class="col-auto">
      <!--
      <label for="purchase-send-at">
        Send At
      </label>
      <div class="input-group">
        <input
          type="date"
          name="send_at_date"
          id="purchase-send-at-date"
          class="form-control"
          v-model="send_at_date"
        />

        <input
          type="time"
          name="send_at_time"
          id="purchase-send-at-time"
          class="form-control"
          v-model="send_at_time"
        />

        <input
          type="hidden"
          name="purchase[send_at]"
          id="purchase-send-at"
          v-model="send_at"
        />
      </div>
      -->
      <purchase-send-at
        labelText="Send At"
        name="purchase[send_at]"
        :value="send_at"
      />
    </div>

    <div class="col-auto">
      <label for="purchase-status">
        Payment Status
      </label>
      <purchase-status-select
        selectName="purchase[status]"
        :status="status || 'completed'"
      ></purchase-status-select>
    </div>
  </div>

  <div class="form-group">
    <label for="purchase-notes">
      Buyer Notes
    </label>
    <textarea
      name="purchase[notes]"
      id="purchase-notes"
      v-model="notes"
      class="form-control"
    ></textarea>
  </div>

  <div class="form-group">
    <label for="purchase-internal-notes">
      Internal Notes
    </label>
    <textarea
      name="purchase[internal_notes]"
      id="purchase-internal-notes"
      v-model="internal_notes"
      class="form-control"
    ></textarea>
  </div>

  <hr />

  <tag-select
    type="purchase[tag_ids][]"
    :selectedTags="tagSlugs"
    noButtons
  ></tag-select>

  <hr />

  <h4>Purchase Download Details</h4>

  <div class="form-group">
    <label for="purchase-download-access-count">
      Download URL Access Count
    </label>

    <input
      type="number"
      name="purchase[download_access_count"
      id="purchase-download-access-count"
      class="form-control"
      v-model="download_access_count"
    />
  </div>

  <hr />

  <h4>PayPal Payment Details</h4>

  <p class="alert alert-warning" role="alert">
    The following should only be filled in if you have the specific PayPal transaction details.
  </p>

  <div class="form-group row">
    <div class="col-6">
      <label for="purchase-merchant-code">
        Merchant Code
      </label>
      <div>
        <input
          type="text"
          name="purchase[merchant_code]"
          id="purchase-merchant-code"
          class="form-control"
          v-model="merchant_code"
        />
      </div>
    </div>

    <div class="col-6">
      <label for="purchase-merchant-email">
        Merchant Email
      </label>
      <div class="input-group">
        <input
          type="text"
          name="purchased[merchant_email]"
          id="purchase-merchant-email"
          class="form-control"
          v-model="merchant_email"
        />
      </div>
    </div>
  </div>

  <div class="form-group row">
    <div class="col-6">
      <label for="purchase-payment-id">
        PayPal Payment ID
      </label>
      <input
        type="text"
        name="purchase[external_payment_id]"
        id="purchase-payment-id"
        v-model="external_payment_id"
        class="form-control"
      />
    </div>
    <div class="col-6">
      <label for="purchase-payer-id">
        PayPal Payer ID
      </label>
      <input
        type="text"
        name="purchase[external_payer_id]"
        id="purchase-payer-id"
        v-model="external_payer_id"
        class="form-control"
      />
    </div>
  </div>

  <div class="form-group row">
    <div class="col-6">
      <label for="purchase-payment-token">
        PayPal Payment Token
      </label>
      <input
        type="text"
        name="purchase[external_payment_token]"
        id="purchase-payment-token"
        v-model="external_payment_token"
        class="form-control"
      />
    </div>
    <div class="col-6">
      <label for="purchase-payment-url">
        PayPal Payment Url
      </label>
      <input
        type="text"
        name="purchase[external_payment_url]"
        id="purchase-payment-url"
        v-model="external_payment_url"
        class="form-control"
      />
    </div>
  </div>

  <button
    type="submit"
    class="form-control btn btn-primary"
  >
    {{ actionLbl }} Purchase
    <spinner size="small" v-if="loading"></spinner>
  </button>
</form>
</template>

<script>
import Spinner from 'vue-simple-spinner'

import Datetime from '@/components/Datetime'
import PurchaseStatusSelect from '@/components/PurchaseStatusSelect'
import PurchasableItemSearch from '@/components/PurchasableItemSearch'
import TagSelect from '@/components/TagSelect'

import TagMixin from '@/mixins/TagMixin'

import PurchaseStore from '@/stores/PurchaseStore'

import { mapState } from 'vuex'

export default {
  data () {
    let state = PurchaseStore.state
    state.loading = false
    state.query = undefined
    state.searchResults = []

    return state
  },

  mixins: [
    TagMixin
  ],

  computed: mapState({
    actionLbl () {
      return this.purchaseId ? 'Edit' : 'Create'
    },

    actionUrl () {
      return this.apiUrl(
        '/purchases' + (
          this.purchaseId ? ('/' + this.purchaseId) : ''
        ), true
      )
    },

    methodType () {
      return this.purchaseId ? 'PUT' : 'POST'
    },

    calculatedGross: {
      get () {
        return this.gross || this.calculateItems
      },

      set () {
        this.gross = this.gross || this.calculateItems
      }
    },

    calculatedNet: {
      get () {
        return this.net || (this.calculateItems + this.calculatedFee)
      },

      set () {
        this.net = this.net || (this.calculateItems + this.calculatedFee)
      }
    },

    calculatedFee: {
      get () {
        const calculated = this.calculateItems
        return this.fee || ((calculated * 0.7) - calculated).toFixed(2)
      },

      set () {
        const calculated = this.calculateItems
        this.net = this.fee || ((calculated * 0.7) - calculated).toFixed(2)
      }
    },

    calculateItems () {
      let total = 0

      this.purchasable_items.map((item) => {
        total += Number.parseFloat(item.price)
      })

      return total
    },

    /*
    formattedPurchasedAt () {
      if (this.purchased_at) {
        return this.$root.dateTimeLocalFmt(this.purchased_at)
      }
    },

    formattedSendAt () {
      this.send_at = this.send_at || this.purchased_at
      if (this.send_at) {
        return this.$root.dateTimeLocalFmt(this.send_at)
      }
    }
    */

    purchased_at_date: {
      get () {
        const purchasedAt = this.getLocalDateTimeAt(this.purchased_at)

        return [
          purchasedAt.getUTCFullYear(),
          this.$root.zeropad(purchasedAt.getUTCMonth() + 1),
          this.$root.zeropad(purchasedAt.getUTCDate())
        ].join('-')
      },

      set (purchasedAtDate) {
        return purchasedAtDate // new Date(sendAtDate + 'T' + this.send_at_time)
      }
    },

    purchased_at_time: {
      get () {
        const purchasedAt = this.getLocalDateTimeAt(this.purchased_at)

        return [
          this.$root.zeropad(purchasedAt.getHours()),
          this.$root.zeropad(purchasedAt.getMinutes())
        ].join(':')
      },

      set (purchasedAtTime) {
        return purchasedAtTime
      }
    },

    // Accommodate non-standard timestamp format.
    formattedPurchasedAt: {
      get () {
        return this.$root.dateTimeFmt(this.purchased_at)
      },

      set (newPurchasedAt) {
        this.purchased_at = this.$root.dateTimeFmt(newPurchasedAt)

        return this.purchased_at
      }
    },

    send_at_date: {
      get () {
        const sendAt = this.getLocalDateTimeAt(this.send_at)

        return [
          sendAt.getUTCFullYear(),
          this.$root.zeropad(sendAt.getUTCMonth() + 1),
          this.$root.zeropad(sendAt.getUTCDate())
        ].join('-')
      },

      set (sendAtDate) {
        return sendAtDate
      }
    },

    send_at_time: {
      get () {
        const sendAt = this.getLocalDateTimeAt(this.send_at)

        return [
          this.$root.zeropad(sendAt.getHours()),
          this.$root.zeropad(sendAt.getMinutes())
        ].join(':')
      },

      set (sendAtTime) {
        return sendAtTime
      }
    },

    // Accommodate non-standard timestamp format.
    formattedSendAt: {
      get () {
        return this.$root.dateTimeFmt(this.send_at)
      },

      set (newSendAt) {
        this.send_at = this.$root.dateTimeFmt(newSendAt)

        return this.send_at
      }
    },

    base: state => state.base,
    found_purchasable_items: state => state.PurchasableItemModule.found_purchasable_items
  }),

  components: {
    'purchased-at': Datetime,
    'purchase-send-at': Datetime,
    'purchase-status-select': PurchaseStatusSelect,
    'purchasable-item-search': PurchasableItemSearch,
    'spinner': Spinner,
    'tag-select': TagSelect
  },

  props: [
    'purchaseId'
  ],

  created () {
    this.get()
    this.$on('purchaseStatusChange', this.setStatus)
  },

  methods: {
    setStatus (statuses) {
      this.status = status
    },

    addPurchasableItem () {
      const select = document.getElementById('found-purchasable-items')
      const option = select.options[select.selectedIndex]

      if (this.canChangePurchasableItem(option)) {
        const item = {
          name: option.text,
          id: option.value,
          price: option.dataset.price
        }

        this.gross = (parseFloat(this.gross) || 0) + parseFloat(item.price)

        PurchaseStore.state.purchasable_items.push(item)
      }
    },

    canChangePurchasableItem (option) {
      if (option.dataset.subscription && this.status === 'completed') {
        alert('Subscriptions cannot be added to a purchase while the purchase status is set to \'complete\'.')

        return false
      }

      return true
    },

    get () {
      if (this.purchaseId) {
        this.apiGet('/purchases/' + this.purchaseId, PurchaseStore, true).then((resp) => {
          this.purchasable_items = resp.purchasable_items.map((item) => {
            item.attributes.id = item.id
            return item.attributes
          })

          this.tags = resp.tags.map((tag) => {
            tag.attributes.id = tag.id
            return tag.attributes
          })
        }, this.processErrors)
      } else {
        this.apiGet('/new/purchase', PurchaseStore, true).then((resp) => {
          this.purchasable_items = []
          this.tags = []
        })
      }
    },

    getLocalDateTimeAt (dt) {
      return new Date(dt || Date.now())
    },

    removePurchasableItem (ev) {
      const id = ev.target.value

      if (
        !ev.target.checked &&
        confirm('Are you sure you want to remove this item from the purchase?')
      ) {
        this.purchasable_items = this.purchasable_items.filter((item) => {
          return item.id !== id
        })
      } else if (!ev.target.checked) {
        ev.target.checked = true
      }
    },

    resetSentAt () {
    },

    submit (ev) {
      if (!this.purchasable_items.length) {
        alert('You must add a purchasable item to complete this purchase.')
      } else {
        // this.purchased_at = this.purchased_at_date + ' ' + this.purchased_at_time

        this.loading = true

        this.bindSubmit(ev).then((resp) => {
          this.loading = false
          const pid = resp.body.data.id

          this.$router.push({
            name: 'purchase',
            params: {
              purchaseId: pid
            }
          })
        }, (errs) => {
          this.loading = false
          this.$parent.$emit('processErrors', errs)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PurchaseForm.vue